module.exports = __webpack_public_path__ + "img/progress_094.de02822e.png";